module.exports = __webpack_public_path__ + "media/theme/icon__payment__visa-2cfe1ab2.svg";